export default "__VITE_ASSET__Ddw2ap8$__"